import React from 'react';

import DataGrid, {
  Column,
  Editing,
  Paging,
  Selection,
  Toolbar,
  Item,
} from 'devextreme-react/data-grid';

import { Button } from 'devextreme-react/button';

import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';
import { reports } from './data.js';

const dataSource = new DataSource({
  store: new ArrayStore({
    data: reports,
    key: 'id',
  }),
});

class ReportGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedItemKeys: [],
    };
    this.selectionChanged = this.selectionChanged.bind(this);
    this.deleteRecords = this.deleteRecords.bind(this);
  }

  render() {
    return (
      <div id="report-grid-wrapper">
        <DataGrid id="report-grid"
          dataSource={dataSource}
          showBorders={true}
          selectedRowKeys={this.state.selectedItemKeys}
          onSelectionChanged={this.selectionChanged}
        >
          <Selection mode="multiple" />
          <Paging enabled={false} />
          <Editing
            mode="cell"
            allowUpdating={true}
            allowAdding={true}
            allowDeleting={true} />

          <Column dataField="id" caption="Id" width={55} />
          <Column dataField="name" caption="Name" />
          <Column dataField="createdDate" caption="Created date" dataType="date" allowEditing="false" />
          <Toolbar>
            <Item name="addRowButton" showText="always" />
            <Item location="after">
              <Button
                onClick={this.deleteRecords}
                icon="trash"
                disabled={!this.state.selectedItemKeys.length}
                text="Delete Selected Records" />
            </Item>
          </Toolbar>
        </DataGrid>
      </div>
    );
  }

  deleteRecords() {
    this.state.selectedItemKeys.forEach((key) => {
      dataSource.store().remove(key);
    });
    this.setState({
      selectedItemKeys: [],
    });
    dataSource.reload();
  }

  selectionChanged(data) {
    this.setState({
      selectedItemKeys: data.selectedRowKeys,
    });
  }
}

export default ReportGrid;